import { Constants } from '@leverege/api-redux';
import FotaReducer from "../reducer/FotaReducer.js";
function getId(idOrObj) {
  return typeof idOrObj === 'object' && idOrObj != null ? idOrObj?.id : idOrObj;
}
function translateRes(res) {
  return {
    ...res,
    limit: Number(res?.limit),
    offset: Number(res?.offset)
  };
}
function getResourceId(resourceId, queryName = 'default') {
  return `${resourceId}$${queryName}`;
}
function createCrudl(path, idOrObj, crudlOptions) {
  const crudId = getId(idOrObj);
  return {
    canList: (opts, extra) => {
      return async (dispatch, getState, {
        api
      }) => {
        const query = {
          ...opts?.query,
          test: true
        };
        const toCall = async () => {
          const nApi = crudlOptions.getApi(api);
          const res = await nApi.get(path, query);
          dispatch({
            type: Constants.ALLOWED_SET,
            resourceId: path,
            action: 'list',
            allowed: res.allowed === true
          });
          return res.allowed === true;
        };
        const promise = crudlOptions.cache.get({
          path,
          method: 'list',
          opts,
          query,
          extra
        });
        if (!extra?.noCache && promise) {
          return promise;
        }
        return crudlOptions.cache.set(toCall, {
          path,
          method: 'list',
          opts,
          query,
          extra
        }, {
          ttl: extra?.ttl
        });
      };
    },
    list: (opts, extra) => {
      const resourceId = getResourceId(path, extra?.queryName);
      return async (dispatch, getState, {
        api
      }) => {
        const toCall = async () => {
          const nApi = crudlOptions.getApi(api);
          dispatch({
            type: FotaReducer.STATUS,
            resourceId,
            status: 'loading'
          });
          let res;
          try {
            res = await nApi.get(path, opts?.query);
            dispatch({
              type: FotaReducer.STATUS,
              resourceId,
              status: FotaReducer.DONE
            });
            dispatch({
              type: FotaReducer.LIST,
              resourceId,
              ...translateRes(res),
              extra: {
                query: opts?.query
              }
            });
          } catch (error) {
            dispatch({
              type: FotaReducer.STATUS,
              resourceId,
              status: FotaReducer.ERROR,
              error
            });
            throw error;
          }
          return res;
        };
        const promise = crudlOptions.cache.get({
          path,
          method: 'list',
          opts,
          extra
        });
        if (!extra?.noCache && promise) {
          return promise;
        }
        return crudlOptions.cache.set(toCall, {
          path,
          method: 'list',
          opts,
          extra
        }, {
          ttl: extra?.ttl
        });
      };
    },
    canGet: (innerId = crudId, opts, extra) => {
      const id = getId(innerId);
      return async (dispatch, getState, {
        api
      }) => {
        const query = {
          ...opts?.query,
          test: true
        };
        const toCall = async () => {
          const nApi = crudlOptions.getApi(api);
          const res = await nApi.get(`${path}/${id}`, query);
          dispatch({
            type: Constants.ALLOWED_SET,
            resourceId: `${path}/${id}`,
            action: 'get',
            allowed: res.allowed === true
          });
          return res.allowed === true;
        };
        const promise = crudlOptions.cache.get({
          path,
          method: 'get',
          opts,
          query,
          extra
        });
        if (!extra?.noCache && promise) {
          return promise;
        }
        return crudlOptions.cache.set(toCall, {
          path,
          method: 'get',
          opts,
          query,
          extra
        }, {
          ttl: extra?.ttl
        });
      };
    },
    get: (innerId = crudId, opts, extra) => {
      const id = getId(innerId);
      const resourceId = getResourceId(`${path}/${id}`, extra?.queryName);
      return async (dispatch, getState, {
        api
      }) => {
        const toCall = async () => {
          const nApi = crudlOptions.getApi(api);
          dispatch({
            type: FotaReducer.STATUS,
            resourceId,
            status: 'loading'
          });
          let res;
          try {
            res = await nApi.get(`${path}/${id}`, opts?.query);
            dispatch({
              type: FotaReducer.STATUS,
              resourceId,
              status: FotaReducer.DONE
            });
            dispatch({
              type: FotaReducer.LIST,
              resourceId,
              total: 1,
              count: 1,
              limit: 1,
              offset: 0,
              items: [res?.[path]]
            });
          } catch (error) {
            dispatch({
              type: FotaReducer.STATUS,
              resourceId,
              status: FotaReducer.ERROR,
              error
            });
            throw error;
          }
          return res;
        };
        const promise = crudlOptions.cache.get({
          path,
          id,
          method: 'get',
          opts,
          extra
        });
        if (!extra?.noCache && promise) {
          return promise;
        }
        return crudlOptions.cache.set(toCall, {
          path,
          id,
          method: 'get',
          opts,
          extra
        }, {
          ttl: extra?.ttl
        });
      };
    },
    canCreate: (createBody, opts, extra) => {
      return async (dispatch, getState, {
        api
      }) => {
        const query = {
          ...opts?.query,
          test: true
        };
        const toCall = async () => {
          const nApi = crudlOptions.getApi(api);
          const res = await nApi.post(path, createBody, query);
          dispatch({
            type: Constants.ALLOWED_SET,
            resourceId: path,
            action: 'create',
            allowed: res.allowed === true
          });
          return res.allowed === true;
        };
        const promise = crudlOptions.cache.get({
          path,
          method: 'create',
          opts,
          createBody,
          query,
          extra
        });
        if (!extra?.noCache && promise) {
          return promise;
        }
        return crudlOptions.cache.set(toCall, {
          path,
          method: 'create',
          opts,
          createBody,
          query,
          extra
        }, {
          ttl: extra?.ttl
        });
      };
    },
    create: (createBody, opts, extra) => {
      const resourceId = getResourceId(path, extra?.queryName);
      return async (dispatch, getState, {
        api
      }) => {
        const nApi = crudlOptions.getApi(api);
        dispatch({
          type: FotaReducer.STATUS,
          resourceId,
          status: 'loading'
        });
        let res;
        try {
          res = await nApi.post(path, createBody, opts?.query);
          dispatch({
            type: FotaReducer.STATUS,
            resourceId,
            status: FotaReducer.DONE
          });
          dispatch({
            type: FotaReducer.LIST,
            resourceId: getResourceId(`${path}/${res.id}`, extra?.queryName),
            total: 1,
            count: 1,
            limit: 1,
            offset: 0,
            items: [res?.[path]]
          });
        } catch (error) {
          dispatch({
            type: FotaReducer.STATUS,
            resourceId,
            status: FotaReducer.ERROR,
            error
          });
          throw error;
        }
        return res;
      };
    },
    canUpdate: (innerId = crudId, update, opts, extra) => {
      const id = getId(innerId);
      return async (dispatch, getState, {
        api
      }) => {
        const query = {
          ...opts?.query,
          test: true
        };
        const toCall = async () => {
          const nApi = crudlOptions.getApi(api);
          const res = await nApi.patch(`${path}/${id}`, update, query);
          dispatch({
            type: Constants.ALLOWED_SET,
            resourceId: `${path}/${id}`,
            action: 'update',
            allowed: res.allowed === true
          });
          return res.allowed === true;
        };
        const promise = crudlOptions.cache.get({
          path,
          method: 'update',
          opts,
          update,
          query,
          extra
        });
        if (!extra?.noCache && promise) {
          return promise;
        }
        return crudlOptions.cache.set(toCall, {
          path,
          method: 'update',
          opts,
          update,
          query,
          extra
        }, {
          ttl: extra?.ttl
        });
      };
    },
    update: (innerId = crudId, update, opts, extra) => {
      const id = getId(innerId);
      const resourceId = getResourceId(`${path}/${id}`, extra?.queryName);
      return async (dispatch, getState, {
        api
      }) => {
        const nApi = crudlOptions.getApi(api);
        dispatch({
          type: FotaReducer.STATUS,
          resourceId,
          status: 'loading'
        });
        let res;
        try {
          res = await nApi.patch(`${path}/${id}`, update, {
            ...opts?.query,
            get: true
          });
          dispatch({
            type: FotaReducer.STATUS,
            resourceId,
            status: FotaReducer.DONE
          });
          dispatch({
            type: FotaReducer.LIST,
            resourceId,
            total: 1,
            count: 1,
            limit: 1,
            offset: 0,
            items: [res?.[path]]
          });
        } catch (error) {
          dispatch({
            type: FotaReducer.STATUS,
            resourceId,
            status: FotaReducer.ERROR,
            error
          });
          throw error;
        }
        return res;
      };
    },
    canDelete: (innerId = crudId, deleteBody, opts, extra) => {
      const id = getId(innerId);
      return async (dispatch, getState, {
        api
      }) => {
        const query = {
          ...opts?.query,
          test: true
        };
        const toCall = async () => {
          const nApi = crudlOptions.getApi(api);
          const res = await nApi.delete(`${path}/${id}`, deleteBody, query);
          dispatch({
            type: Constants.ALLOWED_SET,
            resourceId: `${path}/${id}`,
            action: 'delete',
            allowed: res.allowed === true
          });
          return res.allowed === true;
        };
        const promise = crudlOptions.cache.get({
          path,
          method: 'delete',
          opts,
          deleteBody,
          query,
          extra
        });
        if (!extra?.noCache && promise) {
          return promise;
        }
        return crudlOptions.cache.set(toCall, {
          path,
          method: 'delete',
          opts,
          deleteBody,
          query,
          extra
        }, {
          ttl: extra?.ttl
        });
      };
    },
    delete: (innerId = crudId, deleteBody, opts, extra) => {
      const id = getId(innerId);
      const resourceId = getResourceId(`${path}/${id}`, extra?.queryName);
      return async (dispatch, getState, {
        api
      }) => {
        const nApi = crudlOptions.getApi(api);
        dispatch({
          type: FotaReducer.STATUS,
          resourceId,
          status: 'loading'
        });
        let res;
        try {
          res = await nApi.delete(`${path}/${id}`, deleteBody, opts?.query);
          dispatch({
            type: FotaReducer.STATUS,
            resourceId,
            status: FotaReducer.DONE
          });
          dispatch({
            type: FotaReducer.REMOVE,
            resourceId
          });
          dispatch({
            type: FotaReducer.REMOVE,
            resourceId: getResourceId(path, extra?.queryName),
            id
          });
        } catch (error) {
          dispatch({
            type: FotaReducer.STATUS,
            resourceId,
            status: FotaReducer.ERROR,
            error
          });
          throw error;
        }
        return res;
      };
    }
  };
}
const fwAction = (action, idOrObj, crudlOptions, extra) => {
  return (innerId = idOrObj, body, opts) => {
    return async (dispatch, getState, {
      api
    }) => {
      const nApi = crudlOptions.getApi(api);
      const resourceId = getResourceId(`firmwareRelease/${innerId}`, extra?.queryName);
      dispatch({
        type: FotaReducer.STATUS,
        resourceId,
        status: 'loading'
      });
      let res;
      try {
        const query = {
          ...opts?.query,
          get: true
        };
        res = await nApi.post(`firmwareRelease/${innerId}/${action}`, body, query);
        dispatch({
          type: FotaReducer.STATUS,
          resourceId,
          status: FotaReducer.DONE
        });
        dispatch({
          type: FotaReducer.LIST,
          resourceId,
          total: 1,
          count: 1,
          limit: 1,
          offset: 0,
          items: [res?.firmwareRelease]
        });
      } catch (error) {
        dispatch({
          type: FotaReducer.STATUS,
          resourceId,
          status: FotaReducer.ERROR,
          error
        });
        throw error;
      }
      return res;
    };
  };
};
const fwCanAction = (action, idOrObj, crudlOptions) => {
  return (innerId = idOrObj, body, opts, extra) => {
    return async (dispatch, getState, {
      api
    }) => {
      const resourceId = `firmwareRelease/${innerId}`;
      const path = `firmwareRelease/${innerId}/${action}`;
      const query = {
        ...opts?.query,
        test: true
      };
      const toCall = async () => {
        const nApi = crudlOptions.getApi(api);
        const res = await nApi.post(path, body, query);
        dispatch({
          type: Constants.ALLOWED_SET,
          resourceId,
          action,
          allowed: res.allowed === true
        });
        return res.allowed === true;
      };
      const promise = crudlOptions.cache.get({
        path,
        method: action,
        opts,
        body,
        query,
        extra
      });
      if (!extra?.noCache && promise) {
        return promise;
      }
      return crudlOptions.cache.set(toCall, {
        path,
        method: action,
        opts,
        body,
        query,
        extra
      }, {
        ttl: extra?.ttl
      });
    };
  };
};
function getAll(type, {
  maxRetrieved,
  pageSize = 1000,
  api
}) {
  const listable = api[type]();
  return async (dispatch, getState, {
    api
  }) => {
    const limit = pageSize,
      allOptions = {
        items: []
      };
    let offset = 0,
      total,
      hasMore;
    do {
      // eslint-disable-next-line no-await-in-loop
      const page = await dispatch(listable.list({
        query: {
          limit,
          offset
        }
      }));
      total = page.total;
      allOptions.total = page.total;
      allOptions.items = [...allOptions.items, ...page.items];
      offset += limit;
      hasMore = offset < total && offset < maxRetrieved;
    } while (hasMore);
    return allOptions;
  };
}
export default {
  getId,
  translateRes,
  createCrudl,
  fwAction,
  fwCanAction,
  getAll
};